import $ from 'jquery';

class Grayscale {
  constructor() {
    this.grayscale = $('.gray');

    if (!this.grayscale.length) {
      return;
    }

    $(window).on('load', () => {
      this.initGrayscale();
    });
  }

  initGrayscale() {
    $.each(this.grayscale, (i, el) => {
      const self = $(el);
      let image;

      if (self.prop('tagName') === 'IMG') {
        image = self;
      } else {
        image = self.find('img');
      }

      if (image.length) {
        if (image.hasClass('lazyload') || image.hasClass('lazyloaded')) {
          image.addClass('grayscale grayscale-fade');
        }
      }
    });
  }
}

export default new Grayscale();



// WEBPACK FOOTER //
// ./src/scripts/modules/grayscale.js